import store from 'store2';
export const appStore = store.namespace('default');
//# sourceMappingURL=index.js.map